import { useEffect, useMemo, useState } from "react";
import { Spinner } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Loads live consult times. live=null while loading, false when the calendar can't be read. */
export function useConsultSlots(refreshKey) {
  const [state, setState] = useState({ live: null, slots: [] });
  useEffect(() => {
    let alive = true;
    setState({ live: null, slots: [] });
    fetch(`${API}/next-move/consult-slots`)
      .then((r) => r.json())
      .then((d) => alive && setState({ live: !!d.live && d.slots.length > 0, slots: d.slots || [] }))
      .catch(() => alive && setState({ live: false, slots: [] }));
    return () => { alive = false; };
  }, [refreshKey]);
  return state;
}

/** Day-grouped chips of open consult times (Mountain time). */
export function SlotPicker({ slots, value, onChange }) {
  const days = useMemo(() => {
    const map = new Map();
    for (const s of slots) {
      const [day, time] = s.label.split(" · ");
      if (!map.has(day)) map.set(day, []);
      map.get(day).push({ ...s, time });
    }
    return [...map.entries()];
  }, [slots]);
  return (
    <div data-testid="nm-slot-picker" className="md:col-span-2">
      <p className="font-body text-sm text-cvc-ink-soft">Pick a time <span className="text-xs">(Mountain time · 30 minutes)</span></p>
      <div className="mt-2 space-y-3 max-h-72 overflow-y-auto pr-1">
        {days.map(([day, list]) => (
          <div key={day}>
            <p className="font-body text-xs uppercase tracking-wider text-cvc-ink-soft">{day}</p>
            <div className="mt-1.5 flex flex-wrap gap-2">
              {list.map((s) => (
                <button key={s.start} type="button" data-testid={`nm-slot-${s.start}`} aria-pressed={value === s.start}
                  onClick={() => onChange(s.start)}
                  className={`font-body text-sm px-3.5 py-2 rounded-full border transition-colors ${value === s.start ? "bg-cvc-navy border-cvc-navy text-cvc-cream" : "bg-white border-cvc-border text-cvc-ink hover:border-cvc-navy"}`}>
                  {s.time.replace(" MT", "")}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SlotsLoading() {
  return (
    <p data-testid="nm-slots-loading" className="md:col-span-2 flex items-center gap-2 font-body text-sm text-cvc-ink-soft">
      <Spinner className="animate-spin" /> Checking Jonathan's calendar…
    </p>
  );
}
